module.exports = __webpack_public_path__ + "static/img/icon-back-all.dd27533b.png";